import type {Page} from '@PosterWhiteboard/page/page.class';

interface CommitPosterMutationOptions {
  /** Skip the history snapshot — use only when the change is already part of an outer undoable batch. */
  skipHistory?: boolean;
  /** Skip firing the page 'modified' event — rare; only for transient updates that should not invalidate caches. */
  skipFireModified?: boolean;
}

/**
 * Commits a mutation to the poster.
 *
 * Order is load-bearing — the history snapshot must capture pre-Redux-derive state.
 * Centralizing the trio here means a forgotten step can no longer silently break undo.
 * (The playhead is reconciled against the live duration inside `updateReduxData`, so every
 * Redux publish — not just commits routed through here — keeps `currentTime` within bounds.)
 */
export function commitPosterMutation(page: Page, options: CommitPosterMutationOptions = {}): void {
  if (!options.skipHistory) {
    page.poster.history.addPosterHistory();
  }
  if (!options.skipFireModified) {
    page.fire('modified');
  }
  page.poster.redux.updateReduxData();
}
